import { axios } from 'services/axios';

export const getVgs = () => axios.get('/VisibilityGroups');
